import React from 'react'
import { Grid } from '@material-ui/core'
import { Link } from 'components/ui/Behaviors/Link'
import { useLanguage } from 'store/locale/hooks/useLanguage'
import { useTranslations } from 'hooks/useTranslations'
import { useStyles } from './FooterLinks.styles'

export const FooterLinks = () => {
  const classes = useStyles()

  const { language } = useLanguage()
  const t = useTranslations()

  return (
    <Grid container className={classes.footerWrapper}>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Grid container item direction="row" alignItems="center" justifyContent="center">
          <Link url="https://www.linkedin.com/company/groupe-iliad">
            <img
              className={classes.networksImages}
              width={31}
              height={31}
              alt="link to iliad's Linkedin page"
              src="/assets/pictos/linkedin.svg"
            />
          </Link>
          <Link url="https://twitter.com/GroupeIliad">
            <img
              className={classes.networksImagesAlign}
              width={28}
              height={28}
              alt="link to iliad's X page"
              src="/assets/icons/x.svg"
            />
          </Link>
          <Link url="https://vimeo.com/iliad">
            <img
              className={classes.networksImagesAlign}
              width={31}
              height={31}
              alt="link to iliad's Vimeo page"
              src="/assets/pictos/vimeo.svg"
            />
          </Link>
        </Grid>
        <Grid container item className={classes.links} direction="row" alignItems="center" justifyContent="center">
          <Link route={`/${language}/mentions-legales`}>
            <div className={classes.linksTexte}>{t('legal-information')}</div>
          </Link>
          <Link route={`/${language}/donnees-personnelles`}>
            <div className={classes.linksTexte}>{t('personal-data')}</div>
          </Link>
        </Grid>
        <Grid container item direction="column" alignItems="center" justifyContent="center">
          <div className={classes.copyrightsTexte}>{t('all-rights-reserved')}</div>
        </Grid>
      </Grid>
    </Grid>
  )
}
